import { Platform, Format, AdEnvironment } from './types';

export const API_URL = process.env.REACT_APP_API_URL || window.location.hostname.replace(/^dash/, 'api');
export const IS_PRODUCTION = API_URL === 'api.adjust.com';
export const LOCAL_STORAGE_PREFIX = 'deeplink-generator';

export const SUPPORT_EMAIL = 'support@adjust.com';

export const PLATFORM_OPTIONS = [
  {
    label: 'Android',
    value: Platform.android,
  },
  {
    label: 'iOS',
    value: Platform.ios,
  },
  {
    label: 'Multiplatform',
    value: Platform.multi,
  },
];

export const FORMAT_OPTIONS = [
  {
    label: 'tracker + deeplink',
    value: Format.tdl,
  },
  {
    label: 'ulink',
    value: Format.ulink,
  },
  {
    label: 'jsr',
    value: Format.jsr,
  },
];

export const AD_ENVIRONMENT_OPTIONS = [
  {
    label: 'Email',
    value: AdEnvironment.email,
    formats: [Format.ulink, Format.jsr],
  },
  {
    label: 'Chrome Browser',
    value: AdEnvironment.chromeBrowser,
    formats: [Format.ulink, Format.tdl],
  },
  {
    label: 'Organic Facebook',
    value: AdEnvironment.organicFacebook,
    formats: [Format.ulink, Format.tdl, Format.jsr],
  },
  {
    label: 'Organic Instagram',
    value: AdEnvironment.organicInstagram,
    formats: [Format.ulink, Format.tdl, Format.jsr],
  },
  {
    label: 'Safari browser',
    value: AdEnvironment.safariBrowser,
    formats: [Format.ulink, Format.tdl],
  },
  {
    label: 'Slack',
    value: AdEnvironment.slack,
    formats: [Format.ulink],
  },
  {
    label: 'Organic Snapchat Chats',
    value: AdEnvironment.organicSnapchatChats,
    formats: [Format.tdl],
  },
  {
    label: 'Organic Twitter',
    value: AdEnvironment.organicTwitter,
    formats: [Format.ulink, Format.tdl, Format.jsr],
  },
  {
    label: 'Telegram',
    value: AdEnvironment.telegram,
    formats: [Format.ulink, Format.tdl, Format.jsr],
  },
  {
    label: 'Other',
    value: AdEnvironment.other,
    formats: [Format.ulink, Format.tdl, Format.jsr],
  },
];
